import { FC, ReactNode } from "react";
import { Box } from "./LayoutStartPage.styled";

export type Props = {
  children: ReactNode[];
  design_type?: number;
  image?: string | null;
};

export const LayoutStartPage: FC<Props> = ({
  children,
  design_type,
  image,
}) => {
  return (
    <Box design_type={design_type} image={image}>
      {design_type === 1 && (
        <>
          {children[0]}
          {children[1]}
        </>
      )}
      {design_type === 2 && (
        <>
          {children[1]}
          {children[0]}
        </>
      )}
      {(design_type === 3 || design_type === 4) && (
        <>
          {children[1]}
          {children[2]}
        </>
      )}

      {(design_type === 5 || design_type === 6) && <>{children[1]}</>}
    </Box>
  );
};
